



























































































































































import { Component, Vue, Watch } from "vue-property-decorator";
  import TiendaOnlineClientes from "@/store/modules/TiendaOnlineClientes-module";
import tienda_cart_module from "@/store/modules/tienda_cart_module";
import { RouterNames } from "@/router/routernames";
import { ssmTokenService } from "@/shared/services/token-service";
import { medicalUserService } from "@/shared/services/user-service";
import { UtilsString } from "@/utils/utils-string";
import clientsModule from "@/store/modules/client-module";
import { clients } from "@/shared/dtos/clients";

@Component({
  components: {},
})
export default class home extends Vue {
  public searchQuery = "";
  public dialog = false;
  private clientName: string = "";
  private clientEmail: string = "";
  private clientPhone: string = "";
  private clientNotes: string = "";
  private formValid: boolean = false;
  private saving: boolean = false;
  private clientError: string = "";
  public isShaking = false;

  async created() {
    /* if (TiendaOnlineClientes.TiendaOnlineClienteses.length === 0) {
      if (ssmTokenService.hasToken() && medicalUserService.hasuser()) {
        TiendaOnlineClientes.getTiendaOnlineClientesesTodos();
      } else {
        TiendaOnlineClientes.getTiendaOnlineClienteses();
      }
    }*/
    if (this.$route.query.search) {
      // Llama a la función con el valor del parámetro
      TiendaOnlineClientes.SetSearchQuery(
        UtilsString.ValueOf(this.$route.query.search)
      );
      this.searchQuery = UtilsString.ValueOf(this.$route.query.search);
    }

    tienda_cart_module.loadCart();
    this.dialog = await this.showDialog();

    window.addEventListener("cart-added", this.onCartAdded);
  }

  destroyed() {
    window.removeEventListener("cart-added", this.onCartAdded);
  }

  onCartAdded() {
    this.isShaking = true;
    setTimeout(() => {
      this.isShaking = false;
    }, 600);
  }

  handleSearch() {
    if (this.searchQuery.trim() !== "") {
      this.$router.push({
        name: RouterNames.tienda_productos,
        query: { search: this.searchQuery },
      });
    } else {
      console.log("Por favor, ingresa un término de búsqueda.");
    }
  }
  gohome() {
    this.$router.push({
      name: RouterNames.tienda_productos,
    });
  }
  get cartCount() {
    return tienda_cart_module.cartHistory.current.items.length;
  }

  clearSearch() {
    this.searchQuery = "";
  }
  @Watch("searchQuery")
  cambiarsearch() {
    TiendaOnlineClientes.SetSearchQuery(this.searchQuery);
  }
  goto() {
    this.$router.push({ name: RouterNames.mainlayout });
  }
  gotocard() {
    this.$router.push({ name: RouterNames.carrito_compra });
  }
  public async showDialog() {
    // forzar que el módulo lea y aplique el usuario actual
    await clientsModule.get_mi_user();

    if (clientsModule.tengo_usuario == false) {
      return true;
    }
    return false;
  }
  public get tengo_usuario() {
    return clientsModule.tengo_usuario;
  }

  public get TengoHistorial() {
    return (
      tienda_cart_module.cartHistory.history.length > 0
    );
  }

  // cancelar: solo permitido si el módulo ya tiene usuario (seguridad extra)
  private cancelDialog() {
    if (clientsModule.tengo_usuario) {
      this.dialog = false;
    } else {
      this.clientError = "Debes completar y guardar tus datos para continuar.";
    }
  }

  // guardar cliente: llama a client-module.guardarclients y actualiza estado local y del módulo
  private async saveClient() {
    this.clientError = "";
    // validar form
    const form = this.$refs.clientForm as any;
    if (form && typeof form.validate === "function") {
      const ok = form.validate();
      if (!ok) return;
    }

    this.saving = true;
    try {
      const o = new clients({
        name: this.clientName,
        email: this.clientEmail,
        phone: this.clientPhone,
        notes: this.clientNotes,
      });

      try {
        const created = clientsModule.onSetMiUserData(o);
        // guardar en localStorage con la misma clave que usa el módulo
      } catch {}
      // forzar que el módulo lea y aplique el usuario actual
      await clientsModule.get_mi_user();

      // cierre del diálogo sólo después de guardar correctamente
      this.dialog = false;
    } catch (err) {
      const error: any = err;
      console.error("saveClient error:", error);
      this.clientError = error && error.message ? error.message : String(error);
    } finally {
      this.saving = false;
    }
  }
}
